export const SET_SIDEBAR_OPEN = "SET_SIDEBAR_OPEN";